<template lang="pug">
button.Btn(:class="kind && `--${ kind }`", type="button", @mousedown="onMouseDown")
  slot
</template>
<script>

export default {
  name: 'Btn',

  methods: {
    onMouseDown (e) {
      let { clickClass } = this;
      if (!clickClass)
        return;
      clickClass = typeof clickClass === 'boolean' ? 'btn--click' : clickClass;

      const onAnimEnd = () => {
        this.$el.removeEventListener('animationend', onAnimEnd);
        this.$el.classList.remove(clickClass);
      };

      this.$el.classList.add(clickClass);
      this.$el.addEventListener('animationend', onAnimEnd);
    },
  },

  props: {
    kind: {
      type: String,
      validate: (v) => ~['act', 'act-invert', 'clear', 'a', 'semantic'].indexOf(v),
    },
    clickClass: { type: [Boolean, String] },
  },
};

</script>
<style>
.Btn {
  --h: 32px;
  --font-s: 14px;
  position: relative;
  /* z-index: -1; */

  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: var(--h);
  height: var(--h);
  /*margin-right: 8px;*/
  margin-left: 0;
  padding: 0 var(--pad-h, 12px);
  overflow: hidden;

  color: var(--black);
  font: var(--font);
  font-weight: normal;
  font-size: var(--font-s);
  white-space: nowrap;
  text-align: center;

  background-color: white;
  border: 1px solid var(--border-c);
  border-radius: min(var(--h), var(--border-r, 4px));
  outline: none;
  box-shadow: 0 0 0 0 transparent;
  cursor: pointer;

  /*maya cause problemes*/
  /*transition: all .3s !important;*/

  > * {
    pointer-events: none;
  }

  &.--clear {
    /*padding: 0;*/
    background-color: transparent;
    border: 0;
  }

  > .Icon {
    /* margin-top: -2px; */
    margin-right: 8px;
    margin-left: 8px;

    vertical-align: middle;

    &:first-child { margin-left: 0 }
    &:last-child { margin-right: 0 }
  }

  + .Btn:last-child {
    margin-right: 0;
  }

  &:hover,
  &:focus {
    z-index: 2;

    border-color: #bbb;
    box-shadow: 0 0 0 3px var(--border-c-50);
  }

  &:active,
  &&.--active {
    z-index: 3;

    border-color: var(--black-50);
  }

  i {
    pointer-events: none;
  }

  &.--semantic {
    padding: 0;

    background: transparent;
    border: 0;
    border-radius: 0;
    box-shadow: none;
  }
}

.Btn.--act {
  --color: var(--white);
  --bg-color: var(--brand);
  /* min-width: 164px; */

  color: var(--color);
  line-height: 28px;

  background-color: var(--bg-color);
  border-color: var(--bg-color);
  box-shadow: 0 0 0 0 transparent;

  i svg {
    fill: var(--color);
  }

  &:hover,
  &:active,
  &:focus {
    color: white;

    background-color: var(--bg-color);
    /*background-color: #cc442f;*/
    /*border-color: rgba(255,255,255,.5);*/
    /*border-color: #ff4231;*/
    border-color: transparent;
    box-shadow: 0 0 0 3px var(--brand-50);
  }

  &:disabled {
    color: var(--color);
  }

  &:active {
    box-shadow: 0 0 0 3px var(--brand-50), 0 0 8px 0 rgba(0, 0, 0, 0.65) inset;
  }
}

.Btn.--act-invert {
  --bg-color: var(--white);
  --color: var(--brand);
  color: var(--color);

  background: var(--bg-color);
  border: 1px solid var(--color);

  &:hover,
  &:active,
  &:focus {
    color: var(--color);

    background: var(--bg-color);
    border-color: var(--color);
    box-shadow: 0 0 0 3px var(--brand-50);
  }
}

.Btn.--primary {
  color: var(--white);

  background-color: var(--link);
  border-color: var(--link-50);

  &:hover,
  &:active,
  &:focus {
    border-color: transparent;
    box-shadow: 0 0 0 3px var(--link-50);
  }
}

.Btn.--a {
  width: auto;
  min-width: auto;
  height: auto;
  padding: 0;

  line-height: 1.3;

  background-color: transparent;
  background-image: none;
  /*border-color: transparent !important;*/
  border: none;
  border-radius: 0;
  outline: none;
  box-shadow: none !important;

  &,
  &:visited:visited {
    color: var(--link);
  }

  &:hover,
  &:active,
  &:focus { text-decoration: underline }

  &:disabled { background-color: transparent !important }
}

p .Btn.--a {
  font-size: inherit;
}

.Btn.Btn:disabled,
.Btn.--disabled.Btn.--disabled {
  color: var(--black-50);

  background: var(--pale-grey);
  border-color: var(--pale-grey);
  cursor: not-allowed;

  i svg {
    fill: var(--black-50);
  }

  &:hover {
    box-shadow: 0 0 0 0 transparent;
  }
}
</style>
